export default {
  primary: "#21A0B0",
  secondary: "#037FAC",
  tertiary: "#004F82",
};
